'use client';

import { useIntl } from 'react-intl';

type FaqSectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
};

// In most places on our website we use JSON-LD for structured data markup since that is the recommendation by Google. For FAQ pages,
// we continue to use microdata since it's the easiest way to render HTML tags (specifically links) in the structured data. Next 15 is not supporting
// renderToStaticMarkup which is what we were using the render the answer HTML as a string, so microdata is the next best option at the moment.
const FaqSection = ({ children, className, id, ref }: FaqSectionProps) => {
  const intl = useIntl();
  return (
    <section id={id} itemScope itemType="https://schema.org/FAQPage" className={className} ref={ref} aria-label={intl.formatMessage({ defaultMessage: 'Frequently asked questions' })}>
      {children}
    </section>
  );
};

export default FaqSection;
